import $ from 'jquery';

import Component from '../Component';

export default class Popup extends Component {
    STORAGE_KEY = 'wetheme-popup';

    constructor(theme, element) {
        super(theme, element);

        this.popupSkipDays = parseInt(this.element.dataset.popupTime, 10);
        this.popupDelay = parseInt(this.element.dataset.popupDelay, 10);
        this.testMode = this.element.dataset.popupTestMode === 'true';

        this.load();
    }

    load = () => {
        if (this.testMode) {
            // popup is in test mode - will show immediately in editor and on live site
            this.show();
        } else if (this.isExpiredOrNotSet()) {
            // popup item in localStorage is expired or was not set, show popup this time
            setTimeout(() => {
                this.setExpiry(this.popupSkipDays);
                this.show();
            }, 1000 * this.popupDelay);
        }

        $('.popup--close-btn').on('click', this.hide);
    }

    isExpiredOrNotSet = () => {
        let expired = true;
        const popupInfo = window.localStorage.getItem(this.STORAGE_KEY);
        if (popupInfo) {
            try {
                const expiry = Date.parse(JSON.parse(popupInfo).expiry);
                if (expiry > Date.now()) {
                    expired = false;
                }
            } catch (e) {
                console.warn('Unable to read popup expiry date', e);
            }
        }
        return expired;
    }

    setExpiry = (days) => {
        const expiry = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
        try {
            localStorage.setItem(this.STORAGE_KEY, JSON.stringify({
                expiry: expiry.toISOString(),
            }));
        } catch (e) {
            console.warn('Unable to set popup expiry:', e);
        }
    }

    show = () => {
        this.element.classList.add('visible');
    }

    hide = () => {
        this.element.classList.remove('visible');
    }
}
